import { render, staticRenderFns } from "./Frida.vue?vue&type=template&id=4d5fa816&scoped=true&"
import script from "./Frida.vue?vue&type=script&lang=js&"
export * from "./Frida.vue?vue&type=script&lang=js&"
import style0 from "./Frida.vue?vue&type=style&index=0&id=4d5fa816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5fa816",
  null
  
)

export default component.exports